import { flattenNestedObject } from "../../../../../core/utils/utilFunctions";
import type { SiteGroupDto } from "../../types/SiteGroupDto";
import type { SiteGroupEntity } from "../../types/SiteGroupEntity";

export const SiteGroupDtoToEntity = ({
    dynamicProperties,
    terminalParameters,
    forceTerminalParameters,
    ...rest
}: Readonly<SiteGroupDto>): SiteGroupEntity => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "CHECKBOX" ? propValue.value === "true" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern || "",
            readOnly: propValue.readOnly || false,
            mandatory: propValue.mandatory || false,
            value,
        };
    });

    const flattenedTerminalParameters = flattenNestedObject(terminalParameters, "terminalParameters");
    const flattenedForceParameters = flattenNestedObject(forceTerminalParameters, "forceTerminalParameters");

    return {
        ...rest,
        ...flattenedForceParameters,
        ...flattenedTerminalParameters,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };
};
